import { newApi } from '@lune/auth/api/fetch'
import { apiUrlCollectionFactory, type ApiKindAndUrl } from '@lune/common/api'
import { LoginPage, Root } from '../paths'
import { idToString, type Group } from './types'
import { version } from './version'

export const collectionApi = apiUrlCollectionFactory(
  version,
  Root,
  idToString,
  `/groups`
)

export const GroupApiUrl = (): { group: ApiKindAndUrl<Group, string> } => ({
  group: {
    kind: '#group',
    api: collectionApi
  }
})

export const api = newApi<Group, string>(GroupApiUrl().group, LoginPage)
